import React from "react";
import { Button, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { PlusOutlined, PlayCircleOutlined } from "@ant-design/icons";
import AppLayout from "../components/Layout";
import DataTable from "../components/DataTable";
import SearchBox from "../components/SearchBox";
import usePagedList from "../lib/usePagedList";
import { formatDate } from "../helper";

/** Contacts (students) created in user mode, i.e. not attached to an event. */
const Contacts = () => {
	const navigate = useNavigate();
	const list = usePagedList("students", { params: { mode: "user" } });

	const columns = [
		{ title: "Name", dataIndex: "name", key: "name" },
		{ title: "Email", dataIndex: "email", key: "email", render: (v) => v || "-" },
		{ title: "Phone", dataIndex: "phone_number", key: "phone", render: (v) => v || "-" },
		{
			title: "Added",
			dataIndex: "created_at",
			key: "created_at",
			render: formatDate,
		},
		{
			title: "Event",
			dataIndex: "event",
			key: "event",
			render: (event) => (event ? <Tag color="cyan">{event.name}</Tag> : <span style={{ color: "var(--lcds-muted)" }}>None</span>),
		},
		{
			title: "",
			key: "actions",
			align: "right",
			render: (row) => (
				<Button
					type="primary"
					size="small"
					icon={<PlayCircleOutlined />}
					onClick={() => navigate(`/start-experience?token=${encodeURIComponent(row.token)}&name=${encodeURIComponent(row.name)}`)}
				>
					Start experience
				</Button>
			),
		},
	];

	return (
		<AppLayout
			title="Contacts"
			subtitle="People who can be sent into a VR scenario."
			actions={
				<>
					<SearchBox onSearch={list.onSearch} placeholder="Search name, email or phone" />
					<Link to="/users/create">
						<Button type="primary" size="large" icon={<PlusOutlined />}>
							Add contact
						</Button>
					</Link>
				</>
			}
		>
			<DataTable rows={list.rows} columns={columns} loading={list.loading} pagination={list.pagination} />
		</AppLayout>
	);
};

export default Contacts;
